export enum StaffcalcCategory {
    DEFAULT = 'default',
    RENEWAL = 'renewal',
}
